var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: { widget: _vm.widget },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              !_vm.showSpecificRecordDetails
                ? _c(
                    "div",
                    { staticClass: "header-extra" },
                    [
                      _c("ColumnToggle", {
                        attrs: {
                          "table-name": "pingTrees",
                          "user-settings": _vm.userSettings,
                          "settings-status": _vm.getUserSettingsStatus,
                          "column-settings": _vm.columnSettings
                        },
                        on: { onChange: _vm.updateUserVisibleColumns }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm widget-header-button m-r-5",
                          attrs: { "data-testid": "ring-trees-export-button" },
                          on: {
                            click: function($event) {
                              return _vm.exportToCSV()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("EXPORT_CSV")) +
                              "\n      "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filters.name.value,
                            expression: "filters.name.value"
                          }
                        ],
                        staticClass:
                          "form-control input-md widget-header-input m-r-10",
                        attrs: {
                          type: "search",
                          placeholder: _vm.$t("SEARCH"),
                          "data-testid": "ring-trees-search"
                        },
                        domProps: { value: _vm.filters.name.value },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filters.name,
                              "value",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.isFetchingRingTrees
        ? _c("div", { staticClass: "m-b-15 m-t-10" }, [
            _vm.hasCreateAccess && !_vm.showSpecificRecordDetails
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-success btn-sm",
                    attrs: {
                      type: "button",
                      "data-testid": "show-form-button",
                      disabled: _vm.formActive && !_vm.activeRingTree
                    },
                    on: {
                      click: function($event) {
                        return _vm.showForm(null, $event)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" "),
                    _c("span", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "MENU_LEFT_PINGTREE_ADD",
                          expression: "'MENU_LEFT_PINGTREE_ADD'"
                        }
                      ]
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showSpecificRecordDetails
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm",
                    on: { click: _vm.goToRingTrees }
                  },
                  [
                    _c("i", { staticClass: "fa fa-arrow-left" }),
                    _vm._v(" "),
                    _c("span", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "PING_TREE_SHOW_ALL",
                          expression: "'PING_TREE_SHOW_ALL'"
                        }
                      ]
                    })
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isFetchingRingTrees
        ? _c(
            "div",
            { staticClass: "grid_table_holder" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty",
                  attrs: {
                    data: _vm.ringTrees,
                    "current-page": _vm.currentPage,
                    "page-size": 20,
                    filters: _vm.filters,
                    "hide-sort-icons": true,
                    "data-testid": "v2-ring-trees-table"
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            [
                              !_vm.showAddNewForm &&
                              _vm.ringTrees &&
                              _vm.ringTrees.length == 0
                                ? _c("tr", [
                                    _c("td", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "PING_TREES_HEADER_NONE",
                                          expression: "'PING_TREES_HEADER_NONE'"
                                        }
                                      ],
                                      attrs: { colspan: "100" }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAddNewForm && _vm.hasCreateAccess
                                ? _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "row-inline-new-form slide-down bg-row-even"
                                    },
                                    [
                                      _c(
                                        "td",
                                        { attrs: { colspan: "100" } },
                                        [
                                          _c("RingTreeForm", {
                                            attrs: {
                                              "is-inline-table": "true",
                                              "show-loader":
                                                _vm.isCreateRingTreeLoading
                                            },
                                            on: {
                                              cancel: _vm.hideForm,
                                              submit:
                                                _vm.handleAddRingTreeSubmit
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(displayData, function(ringTree, index) {
                                return [
                                  !(
                                    _vm.isMobile &&
                                    _vm.activeActionRowId == ringTree.id
                                  )
                                    ? _c(
                                        "tr",
                                        {
                                          key: ringTree.id,
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _vm.isMobile
                                            ? _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-list-function btn-expand-actions",
                                                    attrs: {
                                                      disabled:
                                                        _vm.showAddNewForm
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.displayMobileAction(
                                                          ringTree.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-ellipsis-v"
                                                    })
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "name"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings["name"]
                                                        .rowAlign
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "clickable",
                                                      attrs: {
                                                        href: _vm.getRingTreeEditHref(
                                                          ringTree.id
                                                        ),
                                                        "data-testid":
                                                          "ring-tree-name"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.showForm(
                                                            ringTree,
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(
                                                            ringTree.name
                                                          ) +
                                                          "\n              "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "revenueDynamic"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "revenueDynamic"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        ringTree.revenueSettings
                                                          .revenueDynamic
                                                          ? "Yes"
                                                          : "No"
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "minRevenueToRoute"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "minRevenueToRoute"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        _vm.formatCurrency(
                                                          ringTree.minRevenueToRoute
                                                        )
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "revenueOnFailure"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "revenueOnFailure"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        _vm.formatCurrency(
                                                          ringTree
                                                            .revenueSettings
                                                            .revenueOnFailure
                                                        )
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "numTargets"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "numTargets"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName:
                                                            "v-tooltip.right.hover",
                                                          value: _vm.getTargetNamesSplitByComma(
                                                            ringTree
                                                          ),
                                                          expression:
                                                            "getTargetNamesSplitByComma(ringTree)",
                                                          modifiers: {
                                                            right: true,
                                                            hover: true
                                                          }
                                                        }
                                                      ],
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                        "data-testid":
                                                          "ring-tree-targets-count"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(
                                                            ringTree.targets
                                                              .length || 0
                                                          ) +
                                                          "\n              "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "enabled"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "enabled"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c("Status", {
                                                    attrs: { entity: ringTree }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "td",
                                                [
                                                  _c("RingTreeActions", {
                                                    attrs: {
                                                      "create-access":
                                                        _vm.hasCreateAccess,
                                                      "current-ring-tree": ringTree,
                                                      disabled: _vm.formActive,
                                                      "is-admin": _vm.isAdmin,
                                                      href: _vm.getRingTreeEditHref(
                                                        ringTree.id
                                                      )
                                                    },
                                                    on: {
                                                      "collapse-actions": function(
                                                        $event
                                                      ) {
                                                        !_vm.disabled &&
                                                          _vm.hideMobileAction()
                                                      },
                                                      "show-edit-form":
                                                        _vm.showForm,
                                                      "confirm-delete":
                                                        _vm.openConfirmDeleteRingTreeModal,
                                                      "set-status":
                                                        _vm.setRingTreeStatus
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  ringTree.showEditForm ||
                                  _vm.showSpecificRecordDetails
                                    ? _c(
                                        "tr",
                                        {
                                          key: ringTree.id + "-edit",
                                          staticClass:
                                            "row-inline-new-form slide-down bg-row-even"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c("RingTreeForm", {
                                                attrs: {
                                                  "show-loader":
                                                    _vm.isUpdateRingTreeLoading,
                                                  "ring-tree": ringTree
                                                },
                                                on: {
                                                  cancel: _vm.hideForm,
                                                  submit:
                                                    _vm.handleUpdateRingTreeSubmit
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isMobile &&
                                  _vm.activeActionRowId == ringTree.id
                                    ? _c(
                                        "tr",
                                        {
                                          key: ringTree.id + "-mobile",
                                          staticClass:
                                            "mobile-actions ng-animate-disabled slide-right"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "10" } },
                                            [
                                              _c("RingTreeActions", {
                                                attrs: {
                                                  "create-access":
                                                    _vm.hasCreateAccess,
                                                  "current-ring-tree": ringTree,
                                                  disabled: _vm.formActive,
                                                  "is-admin": _vm.isAdmin
                                                },
                                                on: {
                                                  "collapse-actions": function(
                                                    $event
                                                  ) {
                                                    !_vm.disabled &&
                                                      _vm.hideMobileAction()
                                                  },
                                                  "show-edit-form":
                                                    _vm.showForm,
                                                  "confirm-delete":
                                                    _vm.openConfirmDeleteRingTreeModal,
                                                  "set-status":
                                                    _vm.setRingTreeStatus
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    2827282578
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _vm.isMobile ? _c("th") : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.userVisibleColumns, function(col) {
                          return _c("v-th", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: _vm.columnSettings[col].displayName,
                                expression: "columnSettings[col].displayName"
                              }
                            ],
                            key: col,
                            class: _vm.columnSettings[col].class,
                            attrs: {
                              "sort-key": _vm.columnSettings[col].stSort
                            }
                          })
                        }),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c("th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "ACTIONS_COLUMN_HEADER",
                                  expression: "'ACTIONS_COLUMN_HEADER'"
                                }
                              ]
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pagination-min" }, [
                _c(
                  "div",
                  { staticClass: "text-center p-7" },
                  [
                    _c("smart-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage,
                        "total-pages": _vm.totalPages,
                        "max-page-links": 20
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFetchingRingTrees
        ? _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: _vm.showSpecificRecordDetails
                      ? "PING_TREE_HEADER_LOADING"
                      : "PING_TREES_HEADER_LOADING",
                    expression:
                      "showSpecificRecordDetails ? 'PING_TREE_HEADER_LOADING' : 'PING_TREES_HEADER_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDeleteModal
        ? _c("RingTreeDeleteModal", {
            attrs: {
              "ring-tree": _vm.ringTreeForDelete,
              "loading-deleting-ring-tree": _vm.isRingTreeDeleteLoading,
              "loading-ring-tree-references": _vm.isRingTreeReferencesLoading,
              "ring-tree-references": _vm.ringTreeReferences,
              "check-references-text": _vm.checkReferencesText,
              "force-unlink": _vm.forceUnlink
            },
            on: {
              confirm: _vm.confirmDelete,
              close: _vm.closeDeleteModal,
              "set-force-unlink": _vm.setForceUnlink
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }